import { render, staticRenderFns } from "./MatrixType.vue?vue&type=template&id=a92bc3a0&scoped=true&"
import script from "./MatrixType.vue?vue&type=script&lang=js&"
export * from "./MatrixType.vue?vue&type=script&lang=js&"
import style0 from "./MatrixType.vue?vue&type=style&index=0&id=a92bc3a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92bc3a0",
  null
  
)

export default component.exports